import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

/**
 * Service to manage dialog lifecycle across the application
 * Automatically closes all open dialogs on navigation and logout
 */
@Injectable({
  providedIn: 'root'
})
export class DialogManagerService {
  private dialog = inject(MatDialog);
  private router = inject(Router);

  constructor() {
    this.initializeDialogCloseOnNavigation();
  }

  /**
   * Initialize subscription to close all dialogs on navigation
   */
  private initializeDialogCloseOnNavigation(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart)
      )
      .subscribe(() => {
        this.closeAllDialogs();
      });
  }

  /**
   * Close all open dialogs
   * This method can be called manually or is automatically called on navigation
   */
  public closeAllDialogs(): void {
    this.dialog.closeAll();
  }
}
